module.exports = __webpack_public_path__ + "static/img/16.fa08168.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/16.png
// module id = FN3z
// module chunks = 5